let toastEl: HTMLDivElement | null = null;

export function showToast(msg: string, ms = 2800): void {
  if (!toastEl) {
    toastEl = document.createElement('div');
    toastEl.className = 'toast';
    document.body.appendChild(toastEl);
  }
  toastEl.textContent = msg;
  toastEl.style.display = 'block';
  window.setTimeout(() => {
    if (toastEl) toastEl.style.display = 'none';
  }, ms);
}

function appendAll(parent: Element, children: (Node | string | (Node | string)[])[]): void {
  for (const c of children.flat()) {
    parent.append(c instanceof Node ? c : document.createTextNode(String(c)));
  }
}

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  props?: Record<string, string>,
  ...children: (Node | string | (Node | string)[])[]
): HTMLElementTagNameMap[K] {
  const node = document.createElement(tag);
  if (props) {
    for (const [k, v] of Object.entries(props)) {
      if (k === 'className') node.className = v;
      else if (k.startsWith('data-')) node.setAttribute(k, v);
      else (node as HTMLElement & Record<string, string>)[k] = v;
    }
  }
  appendAll(node, children);
  return node;
}
